import { render, staticRenderFns } from "./accordion-component.vue?vue&type=template&id=6f365b95&scoped=true&"
import script from "./accordion-component.vue?vue&type=script&lang=ts&"
export * from "./accordion-component.vue?vue&type=script&lang=ts&"
import style0 from "./accordion-component.vue?vue&type=style&index=0&id=6f365b95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f365b95",
  null
  
)

export default component.exports